import { PlotType } from '@/api/rest/resources/types/plot';
import { getSupportedPlotTypes } from '@/utils/plot';

export const PAGE_SIZE = 5;
export const MIN_PANEL_WIDTH = 320;
export const DEFAULT_PANEL_WIDTH = 539;
export const EXPANDED_PANEL_WIDTH = 982;

export const PLOT_LAND_TYPES = [...getSupportedPlotTypes(), PlotType.MIXED, PlotType.BUILT_UP] as const;
